export default {
    install(Vue, options) {
        /**
         *
         * @param {*} time
         * 将JElement中dataPicker组件返回的国际标准时间转成字符串 yy-MM-dd 00:00:00
         */
        Vue.prototype.formatStandardTime2Start = function(time) {
            var d = new Date(time);
            return (
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " " +
                d.getHours() +
                ":" +
                d.getMinutes() +
                ":" +
                d.getSeconds()
            )
        }

        /**
         *
         * @param {*} time
         * 将JElement中dataPicker组件返回的国际标准时间转成字符串 yy-MM-dd 24:00:00
         */
        Vue.prototype.formatStandardTime2End = function(time) {
            var d = new Date(time);
            return (
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " " +
                "24" +
                ":" +
                d.getMinutes() +
                ":" +
                d.getSeconds()
            )
        }
    }

}


//////////////////
// WEBPACK FOOTER
// ./static/js/utils.js
// module id = null
// module chunks = 